import React, { useState } from "react"
import { Container, Card, CardBody } from "reactstrap"
import MetaTags from 'react-meta-tags';

import * as reportsApi from '../../apis/reportsApi';
import PageTitle from "../../components/Common/PageTitle"
import FilterSalemans from "./FilterComponent/FilterSalemans"
import FilterFromToDate from "./FilterComponent/FilterFromToDate"
import ReportBody from "./ReportPartials/ReportBody";
import ReportButton from "./ReportPartials/ReportButton";
import ReportButtonContainer from "./ReportPartials/ReportButtonContainer";


function BcDoanhSoNhanVien() {

  const [dataHead, setDataHead] = useState([]);
  const [dataBody, setDataBody] = useState([]);

  const [selectedSalemans, setSelectedSalemans] = useState();
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();

  const handleChangeSalemans = (value) => {
    setSelectedSalemans(value);
  };

  const handleChangeFromDate = (value) => {
    setFromDate(value);
  };

  const handleChangeToDate = (value) => {
    setToDate(value);
  };
    
  const renderTable = () => {
    if (selectedSalemans !== undefined) {
      const params = [
          { name: "user_id", value: selectedSalemans },
          { name: "from_date", value: fromDate },
          { name: "to_date", value: toDate }
      ];
      reportsApi.getDataReportsDsnv(params, getDataView, showErr);
    } else {
      alert("Chọn nhân viên");
    }
  }

  const getDataView = (res) => {
    setDataHead(res?.data?.data?.headers);
    setDataBody(res?.data?.data?.details);
  }

  const showErr = (res) => {
    alert(res.message);
  }

  return (
    <React.Fragment>
      <div className="page-content">
      <MetaTags>
          <title>DS nhân viên</title>
        </MetaTags>
        <Container fluid>
          <PageTitle title="Doanh số nhân viên" />
            <Card>
              <CardBody>
                <FilterSalemans
                  onChange={handleChangeSalemans} />

                <FilterFromToDate
                  onChangeFromDate={handleChangeFromDate}
                  onChangeToDate={handleChangeToDate} />
                
                <ReportButtonContainer>
                  <ReportButton
                    label='Xem báo cáo'
                    onClick={renderTable} />
                </ReportButtonContainer>
                
              </CardBody>
            </Card>

            <Card>
              <CardBody>
                <ReportBody 
                  dataHead={dataHead}
                  dataBody={dataBody} />
              </CardBody>
            </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BcDoanhSoNhanVien
